import {
    CLEAR_SESSION_EXPIRED,
    LOGIN_FAIL,
    LOGIN_PENDING,
    LOGIN_SUCCESS,
    LOGOUT,
    SESSION_EXPIRED
} from "../actions/types";
import {useSelector} from "react-redux";

const INITIAL_STATE = {
    loginInProgress: false,
    user: null,
    userData: null,
    sessionExpired: false
};

export default function authReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case LOGIN_PENDING: return {
            ...state,
            loginInProgress: true
        };
        case LOGIN_SUCCESS: return {
            ...state,
            user: action.payload.user,
            userData: action.payload.userData,
            loginInProgress: false
        };
        case LOGIN_FAIL: return {
            ...state,
            user: null,
            userData: null,
            loginInProgress: false
        };
        case LOGOUT: return {
            ...state,
            user: null,
            userData: null,
            loginInProgress: false
        };
        case SESSION_EXPIRED: return {
            ...state,
            sessionExpired: true
        };
        case CLEAR_SESSION_EXPIRED: return {
            ...state,
            sessionExpired: false
        };
        default:
            return state;
    }
}

export const useAuthSelector = () =>
    useSelector(authSelector());

export const authSelector = () => state => state.auth;